import { ColumnViewModel } from '../../shared/column-types';

export const DISEASES_GDA_EVIDENCE: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'geneDescription',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'source',
    'sentenceHTML',
    'text',
    'chemsInSentence',
    'chemIDs',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'geneEnsemblIDs',
    'geneNcbiType',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'pathwayName',
    'pathwayID',
    'chemical_effect',
    'reference',
    'reference_type',
    'pmed_title',
    'nct_phase',
    'association',
    'citation_count',
    'icite_apt',
  ],
  defaultVisible: [
    'geneSymbol',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'sentenceHTML',
    'chemsInSentence',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'chemical_effect',
    'reference',
    'reference_type',
    'pmed_title',
  ],
};